export type PackRuleValue = { value: string | number | boolean };

export type PackRule = {
  ruleCode: string;
  value?: PackRuleValue;
};

export const JURISDICTION_PACK_RULES: Record<string, PackRule[]> = {
  CA: [
    { ruleCode: 'REQUIRE_ID_TYPE', value: { value: true } },
    { ruleCode: 'REQUIRE_ID_NUMBER', value: { value: true } },
    { ruleCode: 'REQUIRE_DOB', value: { value: true } },
    { ruleCode: 'REQUIRE_ADDRESS', value: { value: true } },
    { ruleCode: 'REQUIRE_THUMBPRINT', value: { value: true } },
    { ruleCode: 'REQUIRE_SUPPLIER_PHOTO', value: { value: true } },
    { ruleCode: 'ID_THRESHOLD_MODE', value: { value: 'Always' } },
    { ruleCode: 'HOLD_ENABLED', value: { value: true } },
    { ruleCode: 'HOLD_PERIOD_DAYS', value: { value: 3 } },
    { ruleCode: 'CRV_DAILY_WEIGHT_LIMIT', value: { value: 100 } },
    { ruleCode: 'CRV_DAILY_PRICE_LIMIT', value: { value: 2000 } },
  ],
  TX: [
    { ruleCode: 'REQUIRE_ID_TYPE', value: { value: true } },
    { ruleCode: 'REQUIRE_ID_NUMBER', value: { value: true } },
    { ruleCode: 'ID_THRESHOLD_MODE', value: { value: 'WhenOverThreshold' } },
    { ruleCode: 'ID_THRESHOLD_AMOUNT', value: { value: 25 } },
    { ruleCode: 'REQUIRE_VIN', value: { value: true } },
    { ruleCode: 'REQUIRE_VEHICLE_MAKE', value: { value: true } },
    { ruleCode: 'REQUIRE_LICENSE_PLATE', value: { value: true } },
    { ruleCode: 'HOLD_ENABLED', value: { value: true } },
    { ruleCode: 'HOLD_PERIOD_DAYS', value: { value: 7 } },
    { ruleCode: 'HOLD_MAX_CASH', value: { value: 50 } },
    { ruleCode: 'NO_CASH_PAYMENT', value: { value: false } },
  ],
  FL: [
    { ruleCode: 'REQUIRE_ID_TYPE', value: { value: true } },
    { ruleCode: 'REQUIRE_ID_NUMBER', value: { value: true } },
    { ruleCode: 'ID_THRESHOLD_MODE', value: { value: 'Always' } },
    { ruleCode: 'REQUIRE_SUPPLIER_PHOTO', value: { value: true } },
    { ruleCode: 'HOLD_ENABLED', value: { value: true } },
    { ruleCode: 'HOLD_PERIOD_DAYS', value: { value: 5 } },
  ],
  OH: [
    { ruleCode: 'REQUIRE_ID_TYPE', value: { value: true } },
    { ruleCode: 'REQUIRE_ID_NUMBER', value: { value: true } },
    { ruleCode: 'REQUIRE_SUPPLIER_PHOTO', value: { value: true } },
    { ruleCode: 'REQUIRE_SIGNATURE', value: { value: true } },
    { ruleCode: 'REQUIRE_DL_FRONT', value: { value: true } },
    { ruleCode: 'REQUIRE_DL_BACK', value: { value: true } },
    { ruleCode: 'ID_THRESHOLD_MODE', value: { value: 'Always' } },
  ],
  DEFAULT: [
    { ruleCode: 'REQUIRE_ID_TYPE', value: { value: true } },
    { ruleCode: 'REQUIRE_ID_NUMBER', value: { value: true } },
    { ruleCode: 'ID_THRESHOLD_MODE', value: { value: 'Always' } },
    { ruleCode: 'DO_NOT_BUY_ENABLED', value: { value: true } },
  ],
};
